import { flow, types } from 'mobx-state-tree'
import { appAuthenticateGenerate, appAuthenticateVerify } from '../../../network/AppAuthenticate'
import { authenticateOtp, getAuthenticateCustomerRequest } from '../../../network/authenticateOtp'
import { generateCWOTP } from '../../../network/CwLoginReq'
import { fetchKycDetailsApi } from '../../../network/DomesticMoneyTransfer/fetchKycDetailsApi'
import { generateOTP } from '../../../network/DomesticMoneyTransfer/LoginReq'
import { validateOtpApi, verifyDeleteBeneOtpApi } from '../../../network/DomesticMoneyTransfer/validateOtpApi'
import { pkceGetCodeVerifier } from '../../../util/utill'
import { RootStore } from '../../store'

const { REACT_APP_JFS_CLIENT_ID, REACT_APP_CHANNEL_ID } = process.env

const DomesticMoneyTransferSession = types
  .model('Session', {
    appAccessToken: types.optional(types.string, ''), //app auth AccessToken
    appRefreshToken: types.optional(types.string, ''), //app auth RefreshToken
    appAccessTokenExpiry: types.optional(types.number, -1), //app auth AccessToken expiry
    appRefreshTokenExpiry: types.optional(types.number, -1), //app auth RefreshToken expiry
    appIdToken: types.optional(types.string, ''),
    userAccessToken: types.optional(types.string, ''),
    userRefreshToken: types.optional(types.string, ''),
    userAccessTokenExpiry: types.optional(types.number, -1),
    userRefreshTokenExpiry: types.optional(types.number, -1),
    userIdToken: types.optional(types.string, ''),
    jfsUserId: types.optional(types.string, ''),
    isVerified: types.optional(types.boolean, false),
    lastLoginDate: types.optional(types.string, ''),
    authorizationCode: types.optional(types.string, ''),
    userAuthorizationCode: types.optional(types.string, ''),
    remittanceUserId: types.optional(types.string, ''),
    CHANNEL_ID: types.optional(types.string, String(REACT_APP_CHANNEL_ID)),
    OtpError: types.optional(types.string, ''),
  })
  .views((self) => ({
    get getTokens() {
      return RootStore?.agent?.session
    },
    get getUserToken() {
      return {
        ...RootStore?.agent?.session,
        userAccessToken: RootStore?.bcAppInfo?.userAccessToken,
        userIdToken: RootStore?.bcAppInfo?.userIdentifier,
        userIdentifierToken: RootStore?.bcAppInfo?.userIdentifier,
      }
    },
  }))
  .actions((self) => ({
    appAuthenticateApi: flow(function* appAuthenticateApi() {
      try {
        const codeVerifier = pkceGetCodeVerifier(64)
        const resAppAuthGen = yield appAuthenticateGenerate(
          codeVerifier.toString(),
          REACT_APP_JFS_CLIENT_ID ?? '',
          self,
        )
        self.authorizationCode = resAppAuthGen?.authorizationCode
        if (resAppAuthGen?.authorizationCode?.length > 0) {
          const resAppAuthVerify = yield appAuthenticateVerify(
            resAppAuthGen?.authorizationCode,
            codeVerifier.toString(),
            REACT_APP_JFS_CLIENT_ID ?? '',
            self,
          )

          self.appAccessToken = resAppAuthVerify.appAccessToken
          self.appAccessTokenExpiry = resAppAuthVerify.appAccessTokenExpiry
          self.appRefreshToken = resAppAuthVerify.appRefreshToken
          self.appRefreshTokenExpiry = resAppAuthVerify.appRefreshTokenExpiry
          self.appIdToken = resAppAuthVerify.appIdToken
          return resAppAuthVerify
        }
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    updateUserTokens(tokens: any) {
      const own = self
      own.userAccessToken = tokens?.session?.accessToken?.tokenValue ?? ''
      own.userRefreshToken = tokens?.session?.refreshToken?.tokenValue ?? ''
      own.userAccessTokenExpiry = +tokens?.session?.accessToken?.expiresIn
      own.userRefreshTokenExpiry = +tokens?.session?.refreshToken?.expiresIn
      own.userIdToken = tokens?.session?.userIdentifierToken ?? ''
    },
  }))
  .actions((self) => ({
    sendOtp: flow(function* sendOtp(mobile: string, config?: { mode?: number; purpose?: number, amount?: any }) {
      console.log(config.mode, config.purpose, config.amount, "checkfromsession:::")
      try {
        let response = yield generateOTP(mobile, self.getTokens, config)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    CWsendOtp: flow(function* CWsendOtp(
      mobile: string,
      config?: {
        mode?: number;
        purpose?: number;
        amount?: any;
        scope?: string;
        generate?: string;
        entityType?: number;
        consent?: string;
        aadhaarNo?: string;
        userId?: string; // Added
        bankId?: string;
        consentCode?: string;
      }
    ) {
      console.log("CWsendOtp triggered with config:", config)
      try {
        let response = yield generateCWOTP(mobile, self.getTokens, config)
        console.log(response, ":response:")
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    sendOtpBeniDelete: flow(function* sendOtp(mobile: string, config?: { mode?: number; purpose?: number }) {
      try {
        let response = yield generateOTP(mobile, self.getTokens, config)
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    fetchFeeAndSendOtp: flow(function* fetchFeeAndSendOtp(amount: string, mobile: string, config?: { mode?: number; purpose?: number }) {
      try {
        if (amount !== RootStore.transactionDetails.applicableChargesForAmount) {
          yield RootStore.transactionDetails.getSplitTnxDetails(amount)
        }
        let response = yield generateOTP(mobile, self.getTokens, { ...config, amount })
        return response
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    asyncAuthenticateCustomerBiometric: flow(function* asyncAuthenticateCustomerBiometric(
      fingerprintData: any,
      consent: any,
      authMode: any,
    ) {
      try {
        const req = getAuthenticateCustomerRequest(fingerprintData, consent, authMode)
        const session = yield authenticateOtp(self.getUserToken, req)
        console.log('htag session data', session)
        const userAuthorizationCode = session?.authorizationCode
        self.remittanceUserId = session?.remittanceUserId
        self.userAuthorizationCode = userAuthorizationCode

        self.userAccessToken = session?.userAccessToken ?? ''
        self.userRefreshToken = session?.userRefreshToken ?? ''
        self.userAccessTokenExpiry = +session?.userAccessTokenExpiry
        self.userRefreshTokenExpiry = +session?.userRefreshToken
        self.userIdToken = session?.userIdentifierToken ?? ''
        return session
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    fetchKycDetails: flow(function* fetchKycDetails(fingerPrintData: string, maskedAadhar: string) {
      try {
        const res = yield fetchKycDetailsApi(RootStore.moneyTransferSession.getUserToken, fingerPrintData, maskedAadhar)
        console.log('res=', res)
        RootStore.customerDetails.updateCustomerData(res)
        return res
      } catch (err) {
        RootStore.message.setMessage(err?.message)
        throw err
      }
    }),

    validateOtp: flow(function* validateOtp(otp: string, mobile = RootStore.customerDetails.mobile, config?: { mode?: number; purpose?: number, amount?: any }) {
      try {
        const response = yield validateOtpApi(otp, mobile, self.getTokens, config)
        const session = response?.data
        const userAuthorizationCode = session?.authorizationCode
        self.remittanceUserId = session?.remittanceUserId
        self.userAuthorizationCode = userAuthorizationCode
        self.updateUserTokens(response?.data)
        return response
      } catch (err) {
        const closuredError = () => {
          if (err?.data?.error) {
            return err?.data?.error
          } else {
            return err
          }
        }

        RootStore.message.handleError(closuredError())
        throw err
      }
    }),

    updateUserIdToken(userIdToken: string) {
      self.userIdToken = userIdToken
    },
    updateAuthenticationOtpError(val: string) {
      self.OtpError = val
    },
    verifyDeletionOtp: flow(function* verifyDeletionOtp(otp: string, mobile: string, config?: { mode?: number; purpose?: number, amount?: any }) {
      try {
        const tokens = self.getTokens;
        const response = yield verifyDeleteBeneOtpApi(otp, mobile, tokens, config);
        console.log(response, "response:::");
        (self as any).updateAuthenticationOtpError('');
        console.log("beforereturnnn::::", response)
        return response.data;
      } catch (err) {
        const errorData = err?.data?.error || err;
        (self as any).updateAuthenticationOtpError(errorData?.message || 'Invalid OTP');
        RootStore.message.handleError(errorData);
        throw err;
      }
    }),
  }))

const DomesticMoneyTransferSessionData = DomesticMoneyTransferSession.create({})

export { DomesticMoneyTransferSession, DomesticMoneyTransferSessionData }

